import {
  AcknowledgementLayout,
  LoginLayout,
  PasswordReset,
  PasswordResetMsg,
  Navbar,
} from "@funded-here-interface/common";
import { JwtProvider } from "@funded-here-interface/common/src/providers/JwtProvider";
import {
  resetAuthState,
  setToken,
} from "@funded-here-interface/common/src/features/auth/authSlice_Admin";
import "./App.css";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import StructuredNotePage from "./screens/StructuredNote/StructuredNote";
import OrgDetailsPage from "./screens/OrgDetails/OrgDetailsPage";
import Issusingspv from "./screens/IssusingSPV.tsx/Issusingspv";
import Dashboard from "./screens/PMDashboard/DashBoard";
import CampaignList from "./screens/CampaignList/CampaignList";
import { QueryClientProvider } from "react-query";
import CreateCampaign from "./screens/CreateCampaign/CreateCampaign";
import Login from "./screens/Login/Login";
import { store, persistor, RootState } from "./store";
import { Provider } from "react-redux";
import Notelist from "./screens/Notelist/Notelist";
import PmVerifySkuLoans from "./screens/PmVerifySkuLoans/PmVerifySkuLoans";
import OperationAndRiskLayout from "./layouts/OperationAndRisk/OperationAndRiskLayout";
import ProductLayout from "./layouts/ProductLayout/ProductLayout";
import IndividualList from "./screens/IndividualList/IndividualList";
import InvestorSummary from "./screens/PMDashboard/Components/Investor/InvestorSummary";
import Merchant from "./screens/PMDashboard/Components/MerchantSummary/Merchant";
import Skusummary from "./screens/PMDashboard/Components/SKUSummary/Skusummary";
import VirtualAccounts from "./screens/VirtualAccounts/VirtualAccounts";
import LoanDetails from "./screens/LoanDetails/LoanDetails";
import PmVerifySkuLoanDetails from "./screens/PmVerifySkuLoanDetails/PmVerifySkuLoanDetails";
import Repayment from "./screens/PMRepayment/Repayment";
import IssueNote from "./screens/IssueSNOverview/IssueNote";
import SkuLoanApplication from "./screens/SkuLoanApplication/SkuLoanApplication";
import SalesSupportLayout from "./layouts/SalesSupportLayout/SalesSupportLayout";
import { client } from "./reactQuery";
import TwoFAQRPageCommon from "@funded-here-interface/common/src/pages/TwoFA/TwoFAQRCode";
import Withdraw from "./screens/Withdraw/Withdraw";
import FeatureFlag from "./screens/FeatureFlag/FeatureFlag";
import ExternalAccounts from "./screens/ExternalAccounts/ExternalAccounts";
import Audit from "./screens/Audit/Audit";
import Inventory from "./screens/InventoryOrders/Inventory/Inventory";
import Orders from "./screens/InventoryOrders/Orders/Orders";
import FundPull from "./screens/InventoryOrders/FundPull/FundPull";
import Onboarding from "./screens/SalesOnboarding/Onboarding";
import OnboardingForm from "./screens/SalesOnboarding/OnboardingForm";
import OnboardingFormWrapper from "./screens/SalesOnboarding/OnboardingFormWrapper";
import FundPullAutoRefund from "./screens/MerchantConfiguration/FundPullAutoRefund";

const PrivateRoute = ({ children }: any) => {
  const token = store.getState().auth.token;

  return !token || token === "none" ? <Navigate to={"/login"} /> : children;
};

function App() {
  return (
    <QueryClientProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <JwtProvider
              tokenSelector={(state: RootState) => state.auth}
              resetAuthAction={resetAuthState}
              setTokenAction={setToken}
              persistor={persistor}
            >
              <Routes>
                <Route path="*" Component={() => <Navigate to={"/login"} />} />
                <Route
                  path="/login"
                  element={<LoginLayout content={<Login />} />}
                />
                <Route
                  path="/two-auth-QR-code"
                  element={<Navbar content={<TwoFAQRPageCommon />} />}
                />
                <Route
                  path="/password-reset"
                  element={
                    <AcknowledgementLayout content={<PasswordReset />} />
                  }
                />
                <Route
                  path="/reset-message"
                  element={
                    <AcknowledgementLayout content={<PasswordResetMsg />} />
                  }
                />
                <Route
                  path="/pm-dashboard/:subpath"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Dashboard />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/withdrawal"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Withdraw />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/investorsummary"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<InvestorSummary />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/merchant"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Merchant />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/snusummary"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Skusummary />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/repayment/:id"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Repayment />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/note-list"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Notelist />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/create-campaign"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<CreateCampaign />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/org-list"
                  element={
                    <PrivateRoute>
                      <OperationAndRiskLayout content={<OrgDetailsPage />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/individual-list"
                  element={
                    <PrivateRoute>
                      <OperationAndRiskLayout content={<IndividualList />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/campaign-list"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<CampaignList />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/loan-details"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<LoanDetails />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/verify-sku-loans"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<PmVerifySkuLoans />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/verify-sku-loan-details"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<PmVerifySkuLoanDetails />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/issue-note/:id"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<IssueNote />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/issuer"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Issusingspv />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/structured-note/:tabValue"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<StructuredNotePage />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/virtual-accounts"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<VirtualAccounts />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/external-accounts"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<ExternalAccounts />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/sales-support/:tabValue"
                  element={
                    <PrivateRoute>
                      <SalesSupportLayout content={<SkuLoanApplication />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/audit"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Audit />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/onboarding"
                  element={
                    <PrivateRoute>
                      <SalesSupportLayout content={<Onboarding />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/feature-flags"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<FeatureFlag />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/inventory"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Inventory />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<Orders />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/fund-pull"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<FundPull />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/onboardingForm"
                  element={
                    <PrivateRoute>
                      <SalesSupportLayout content={<OnboardingFormWrapper />} />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/fund-pull-auto-refund"
                  element={
                    <PrivateRoute>
                      <ProductLayout content={<FundPullAutoRefund />} />
                    </PrivateRoute>
                  }
                />
              </Routes>
            </JwtProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
